import {Component, Injector, OnInit} from '@angular/core';
import {BaseComponent} from "../../../base.component";
import {QrCodeOptions} from "./options/qr-code.options";
import {MatDialogRef} from '@angular/material/dialog';

@Component({
  selector: 'app-attribute-selector',
  standalone: false,
  templateUrl: './qr-code.component.html',
  styleUrls: ['./qr-code.component.scss']
})
export class QrCodeComponent extends BaseComponent implements OnInit {
  qrCodeOptions = new QrCodeOptions();
  image?: any;

  constructor(injector: Injector, private readonly matDialogRef: MatDialogRef<QrCodeComponent>) {
    super(injector);
  }

  override ngOnInit() {
    super.ngOnInit();
    this.image = this.qrCodeOptions.space.QRCode;
  }

  override loadOnline() {
    super.loadOnline();
  }

  noAction() {
    this.matDialogRef.close();
  }

  onSubmitClicked() {
  }
}
